<h4 mat-dialog-title>Modification des options</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editTextInputForm" style="margin-top: 20px">
    <mat-dialog-content class="mat__typography">
        <div fxLayout="column" fxLayoutGap="15px">
            <div>
                <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                    <mat-label>{{placeholderTitle}}</mat-label>
                    <input formControlName="placeholder" matInput
                           matTooltip="{{placeholderText}}"
                           placeholder='{{placeholderText}}, par exemple "Veuillez saisir votre nom"'
                           type="text" data-cy="input-text-dialog-placeholder">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                    <mat-label>{{tooltipTitle}}</mat-label>
                    <input formControlName="tooltip" matInput
                           matTooltip="{{tooltipText}}"
                           placeholder="{{tooltipText}}"
                           type="text" data-cy="input-text-dialog-tooltip">
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button (click)="onNoClick()"
                mat-raised-button
                color="primary"
                type="button"
                data-cy="button-text-input-dialog-cancel">
            Annuler
        </button>
        <button mat-raised-button
                cdkFocusInitial
                color="accent"
                type="submit"
                data-cy="button-text-input-dialog-save">
            Sauvegarder
        </button>
    </mat-dialog-actions>
</form>

